<template>
  <div id="app">
    <transition name="fade"
                mode="out-in">
      <router-view v-if="isRouterAlive"></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app',
  provide(){
      return{
          reload:this.reload
      }
  },
  data(){
      return{
          isRouterAlive:true
      }
  },
  methods:{
      reload(){
          this.isRouterAlive = false;
          this.$nextTick(function(){
              this.isRouterAlive = true;
          })
      },

  },
  components: {
  },
  //{path: '/serviceLogin',component: ServiceLogin,name: '职业技能登录页'},
  mounted() {
    if(process.env.INDEX_URL=='mohrss'){
     this.$router.options.routes.push({//插入路由
        name:'登录页面',
        path: '/',
        component: resolve => require(['./views/Index.vue'], resolve)//将组件用require引进来
      });
      this.$router.addRoutes(this.$router.options.routes);//调用addRoutes添加路由
    }else if(process.env.INDEX_URL==''){
      this.$router.options.routes.push({//插入路由
        name:'登录页面',
        path: '/',
        component: resolve => require(['./views/Index.vue'], resolve)//将组件用require引进来
      });
      this.$router.addRoutes(this.$router.options.routes);//调用addRoutes添加路由
    }else {
      this.$router.options.routes.push({//插入路由
        name:'登录页面',
        path: '/',
        component: resolve => require(['./views/Index.vue'], resolve)//将组件用require引进来
      });
      this.$router.addRoutes(this.$router.options.routes);//调用addRoutes添加路由
    }

  }
}

</script>
<style>
  .el-scrollbar__wrap{
     margin-bottom:0 !important;
     overflow-x: hidden !important;
  }
  .red{
    color:red;
  }
</style>




// WEBPACK FOOTER //
// App.vue?1182d1cc